import React from 'react';
import { useParams } from 'react-router-dom';
import { newsData, newsCategories } from '../data/newsData';
import { NewsList } from '../components/NewsList';
import { Sidebar } from '../components/Sidebar';
import { NewsCategories } from '../components/news/NewsCategories';
export const CategoryPage = () => {
  const {
    category
  } = useParams<{
    category: string;
  }>();
  const categoryTitle = category ? category.charAt(0).toUpperCase() + category.slice(1) : '';
  // Filter news by category
  const categoryNews = newsData.filter(item => item.category?.toLowerCase() === category?.toLowerCase());
  // Get featured article (first in the category)
  const featuredArticle = categoryNews.length > 0 ? categoryNews[0] : null;
  const featuredArticleId = featuredArticle ? newsData.findIndex(item => item.title === featuredArticle.title) : 0;
  return <main className="flex-grow container mx-auto px-4 py-6 lg:px-6" data-id="element-355">
      <div className="mb-8" data-id="element-356">
        <h1 className="text-3xl font-bold mb-2" data-id="element-357">{categoryTitle}</h1>
        <p className="text-gray-600" data-id="element-358">
          The latest {categoryTitle.toLowerCase()} news and updates.
        </p>
      </div>
      <NewsCategories categories={newsCategories} activeCategory={category} data-id="element-359" />
      {featuredArticle && <div className="mb-10" data-id="element-360">
          <a href={`/article/${featuredArticleId}`} data-id="element-361">
            <div className="relative" data-id="element-362">
              <img src={featuredArticle.imageUrl} alt={featuredArticle.title} className="w-full h-[400px] object-cover rounded-lg" data-id="element-363" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg" data-id="element-364">
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 hover:text-blue-200 transition-colors" data-id="element-365">
                  {featuredArticle.title}
                </h2>
                <p className="text-white text-opacity-90 mb-2" data-id="element-366">
                  {featuredArticle.excerpt}
                </p>
                <div className="flex items-center text-white text-opacity-75 text-sm" data-id="element-367">
                  <span className="mr-4" data-id="element-368">By {featuredArticle.author}</span>
                  <span data-id="element-369">{featuredArticle.date}</span>
                </div>
              </div>
            </div>
          </a>
        </div>}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-370">
        <div className="lg:col-span-8" data-id="element-371">
          <h2 className="text-xl font-bold mb-6" data-id="element-372">Latest in {categoryTitle}</h2>
          <NewsList category={category} limit={10} data-id="element-373" />
        </div>
        <div className="lg:col-span-4" data-id="element-374">
          <Sidebar data-id="element-375" />
        </div>
      </div>
    </main>;
};